// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

async function fetchSummary(text, length, model) {
	const url = `${process.env.API_URL}/summary/text`;
	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-type": "application/json",
		},
		body: JSON.stringify({
			text: text,
			output_length: length,
			language_model: model,
		}),
	});
	return response;
}

export default fetchSummary;
